<template>
  <div></div>
</template>
<script>
import DomainService from 'domain-service'

export default {
  name: 'LoggingBeacon',
  data() {
    return {
      // all data will be passed through 1 object through the dataset attribute [data-adacado-dataset]
      previousTimestamp: undefined,
      localTrackingEvent: JSON.parse(localStorage.getItem('adacadoTrackingEvent')),
    }
  },
  async beforeMount() {
    // Dispatch and clear any event stored in local storage
    if (this.localTrackingEvent) {
      this.dispatchBeacon(this.localTrackingEvent)
      localStorage.removeItem('adacadoTrackingEvent')
    }
    this.guibus_subscribe('dispatch:beacon', this.handleDispatch)
  },
  beforeDestroy() {
    this.guibus_unsubscribe('dispatch:beacon', this.handleDispatch)
  },
  methods: {
    // Some events lead to page redirects which cause beacon dispatches to be disrupted.
    // In this case we store the event in localStorage and fire the beacon once the redirect has completed
    handleDispatch({ eventId, holdDispatch }) {
      this.previousTimestamp = this.previousTimestamp || Date.now()
      const timeSpent = Date.now() - this.previousTimestamp
      this.previousTimestamp = Date.now()

      if (holdDispatch) {
        localStorage.setItem('adacadoTrackingEvent', JSON.stringify({ eventId, timeSpent }))
      } else {
        this.dispatchBeacon({ eventId, timeSpent })
      }
    },
    // Dispatch an asynchronous signal to BE to log actions on interesting events:
    // e.g. "fourSquares-open", "fourSquares-close", "fourSquares-plan", "fourSquares-design", "fourSquares-advertize", "fourSquares-optimize"
    // Note this url does not include accountId as per NVN it can be resolved on BE
    dispatchBeacon({ eventId, timeSpent }) {
      if (this.$firebaseUser) {
        this.$firebaseUser.getIdToken().then(token => {
          fetch(
            DomainService
              .decorateWithServicesDomain`logging/v1/log/${eventId}/${timeSpent}`,
            {
              method: 'POST',
              headers: {
                Authorization: 'Bearer ' + token,
              },
            }
          )
        })
      } else {
        const initialVisit = localStorage.getItem('adaInitialVisit')
        const initialVisitTimeStamp = new Date(initialVisit).getTime()
        fetch(
          DomainService
            .decorateWithServicesDomain`logging/v1/preauth/log/${eventId}/${timeSpent}/${initialVisitTimeStamp}`,
          {
            method: 'POST',
          }
        )
      }
      
    },
  },
}
</script>
